module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag51_2443AT.385de427.jpg";